import { getOrCreateMemoryDataStore } from "@crystal/utils";
import { CrystalRedux } from "./crystal-redux.js";
const reduxHost = getOrCreateMemoryDataStore("redux-host");
const getReduxHost = () => getOrCreateMemoryDataStore("redux-host");
function initializeReduxHost(initialReducers, preloadedState) {
  if (isReduxHostInitialized())
    throw new Error("Redux host has been initialized already.");
  getReduxHost().set(new CrystalRedux(initialReducers, preloadedState));
}
function isReduxHostInitialized() {
  return !!getReduxHost().get();
}
export {
  getReduxHost,
  initializeReduxHost,
  isReduxHostInitialized,
  reduxHost
};
//# sourceMappingURL=redux-host.js.map
